module.exports = __webpack_public_path__ + "img/lg_ring_g_c_1_0.b7533f22.png";